<template>
    <BaseModal
        class="bill-discount-list-modal"
        :closable="true"
        :hasHeader="false"
        :hasFooter="false"
        ref="baseModalComponent"
    >
        <template v-slot:body>
            <div class="bill-discount-list-form form-group row">
                <BillDiscountsList class="col-md" @allDiscountsRemoved="close" @discountRemoved="onDiscountRemoved" />
            </div>
        </template>
    </BaseModal>
</template>

<script setup lang="ts">
    import { ref } from "vue";

    import BaseModal from "@/components/dialog/BaseModal.vue";
    import BillDiscountsList from "@/components/payment/BillDiscountsList.vue";

    const emit = defineEmits(["discountRemoved"]);

    // define html refs
    const baseModalComponent = ref<InstanceType<typeof BaseModal> | null>(null);

    function onDiscountRemoved() {
        emit("discountRemoved");
    }

    // define exposed
    function show() {
        baseModalComponent.value?.show();
    }

    function close() {
        baseModalComponent.value?.close();
    }

    defineExpose({
        show,
        close,
    });
</script>

<style lang="scss">
    @use "./../../../../assets/styles/scss/shared/_variables.scss";

    .modal.bill-discount-list-modal {
        .modal-body {
            padding: 1.5em 2em;
        }

        .bill-discount-list-form {
            margin-bottom: 1em;
        }
    }
</style>
